import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { REALTOR } from "../lib/brand";

export default function TableOfContents({ open, pages, currentIndex, onClose, onNavigate }) {
    return (
        <AnimatePresence>
            {open && (
                <>
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="fixed inset-0 z-40 bg-navy/40 backdrop-blur-sm"
                    />
                    <motion.aside
                        initial={{ x: "-100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "-100%" }}
                        transition={{ duration: 0.35, ease: "easeOut" }}
                        data-testid="toc-drawer"
                        className="fixed top-0 left-0 z-50 h-full w-full sm:w-[420px] bg-cream border-r border-hairline shadow-xl flex flex-col"
                    >
                        <TocHeader onClose={onClose} />
                        <nav className="flex-1 overflow-y-auto toc-scroll">
                            {pages.map((p, i) => (
                                <TocItem
                                    key={p.id}
                                    page={p}
                                    index={i}
                                    isCurrent={i === currentIndex}
                                    onClick={() => onNavigate(i)}
                                />
                            ))}
                        </nav>
                        <TocFooter />
                    </motion.aside>
                </>
            )}
        </AnimatePresence>
    );
}

function TocHeader({ onClose }) {
    return (
        <div className="flex items-center justify-between p-6 border-b border-hairline">
            <div>
                <div className="eyebrow">Contents</div>
                <div className="serif-display text-2xl text-navy mt-1">Moving to Florida</div>
            </div>
            <button
                onClick={onClose}
                data-testid="toc-close-btn"
                className="text-navy hover:text-coral transition-colors p-2"
            >
                <X size={20} />
            </button>
        </div>
    );
}

function TocItem({ page, index, isCurrent, onClick }) {
    const numberLabel = String(index + 1).padStart(2, "0");
    return (
        <button
            onClick={onClick}
            data-testid={`toc-item-${page.id}`}
            className={`w-full text-left flex items-baseline gap-4 px-6 py-4 border-b border-hairline transition-colors hover:bg-sand ${isCurrent ? "bg-sand" : ""}`}
        >
            <span className="serif-display text-2xl text-coral w-8 flex-shrink-0">
                {numberLabel}
            </span>
            <span className="flex-1">
                <span className="block font-serif text-xl text-navy leading-snug">
                    {page.title}
                </span>
                {isCurrent && (
                    <span className="eyebrow mt-1 inline-block">Currently reading</span>
                )}
            </span>
        </button>
    );
}

function TocFooter() {
    return (
        <div className="p-6 border-t border-hairline bg-sand/60">
            <div className="eyebrow mb-2">Prepared by</div>
            <div className="serif-display text-2xl text-navy">{REALTOR.name}</div>
            <div className="text-xs text-muted2 mt-1">
                REALTOR® + Loan Originator · {REALTOR.phone}
            </div>
        </div>
    );
}
